import React, { useRef, useMemo, useState } from "react";
import { Icon, IconButton, Table as _Table } from "rsuite";
import { withRouter } from "react-router-dom";
import queryString from "query-string";

import { FilterSectionFlexboxGrid, StyledItemFitWidth, StyledItemAutoMargin } from "components/base/FitContainers";
import { ButtonRow } from "components/base/BaseButton";
import { Spacer } from "components/base/Spacer";
import Table from "components/Table";
import RangesFilters from "./RangesFilters";
import AddNewRange from "./AddNewRange";

const { Column, HeaderCell, Cell } = _Table;


const Ranges = ({
    items, loading, count, page, sde_key: sdeKey, service, history, isMobile, update,
    filters: propsFilters, onChangeFilters: changeFilters, showAddRangesButton
}) => {

    const filtersRef = useRef(null);
    const [filters, setFilters] = useState({});

    const columns = useMemo(() => {
        return [
            {
                label: "Range name",
                dataKey: "name",
                value: ({ name, mcc, mnc }) => mcc ? `${name} (${mcc}${mnc || ""})` : name,
                flexGrow: 1
            },
            {
                label: "Range prefix",
                dataKey: "prefix",
                flexGrow: 1
            },
            {
                label: "Test numbers",
                dataKey: "test_number",
                flexGrow: 1
            },
            { label: "Numbers", dataKey: "all_numbers", align: "left" },
            { label: "Allocated", dataKey: "allocated_numbers", align: "left" }
        ];
    }, []);

    const onChangeFilters = (_filters) => {
        setFilters(_filters);

        update(1, _filters);
        changeFilters(_filters);
    };

    const onUpdateRef = (ref) => {
        filtersRef.current = ref;
    };

    const onClickList = () => {
        const params = { ...propsFilters, sde_key: sdeKey };
        const query = queryString.stringify(params);

        history.push(`/ranges-numbers?${query}`);
    };

    return <>
        <FilterSectionFlexboxGrid controlable={!isMobile} centered>
            <StyledItemFitWidth isMobile={isMobile} controlable={!isMobile}>
                <RangesFilters
                    service={service}
                    onChange={onChangeFilters}
                    onUpdateRef={onUpdateRef}
                />
            </StyledItemFitWidth>
            <StyledItemAutoMargin>
                {showAddRangesButton && <AddNewRange
                    service={service}
                    sde_key={sdeKey}
                    disabled={!!sdeKey}
                    update={() => update(page)}
                />}
            </StyledItemAutoMargin>
        </FilterSectionFlexboxGrid>

        <Spacer size={13} />

        <Table
            data={items}
            height="50%"
            width="100%"
            loading={loading}
            columns={columns}
            count={count}
            page={page}
            getItems={(page) => update(page, filters)}
            ispagination
            hidePerPage
            ActionCell={ActionCell(onClickList)}
        />
    </>;
};

export default withRouter(Ranges);


const ActionCell = (onClickList) => (
    <Column align="center">
        <HeaderCell>Options</HeaderCell>
        <Cell>
            {({ sde_key }) => (
                <div style={{ position: "relative", "top": "-2px" }}>
                    <ButtonRow
                        as={IconButton}
                        mr={0}
                        icon={<Icon icon="list" />}
                        onClick={() => onClickList(sde_key)}
                    />
                </div>
            )}
        </Cell>
    </Column>
);